export const API_BASE_URL =
  process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:8000/api/v1'

export const ROLES = {
  ADMIN: 'admin',
  LANDLORD: 'manager',
  TENANT: 'tenant',
}

export const ROUTES = {
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  ADMIN_DASHBOARD: '/admin',
  LANDLORD_DASHBOARD: '/landlord',
  LANDLORD_BILLING: '/landlord/billing',
  LANDLORD_BILLING_SUCCESS: '/landlord/billing/success',
  TENANT_DASHBOARD: '/tenant',
  NOT_FOUND: '/404',
}

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER: 'user',
  SUBSCRIPTION_STATUS: 'subscription_status',
  REQUIRES_SUBSCRIPTION: 'requires_subscription',
  INTENDED_PLAN: 'intended_plan',
  // The company the person works in (P4d): this tab's copy in sessionStorage,
  // the last choice in localStorage.
  COMPANY_ID: 'company_id',
}

// Plan keys for pricing: starter_monthly, starter_yearly, professional_monthly, professional_yearly
export const PLAN_KEYS = {
  STARTER_MONTHLY: 'starter_monthly',
  STARTER_YEARLY: 'starter_yearly',
  PROFESSIONAL_MONTHLY: 'professional_monthly',
  PROFESSIONAL_YEARLY: 'professional_yearly',
}

export const PLAN_PRICE_IDS = {
  starter_monthly: process.env.NEXT_PUBLIC_STRIPE_PRICE_STARTER_MONTHLY || '',
  starter_yearly: process.env.NEXT_PUBLIC_STRIPE_PRICE_STARTER_YEARLY || '',
  professional_monthly:
    process.env.NEXT_PUBLIC_STRIPE_PRICE_PROFESSIONAL_MONTHLY || '',
  professional_yearly:
    process.env.NEXT_PUBLIC_STRIPE_PRICE_PROFESSIONAL_YEARLY || '',
}

// File upload constants
export const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10 MB

// Valid file extensions
export const ALLOWED_PHOTO_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.bmp',
  '.webp',
  '.svg',
  '.mp4',
  '.mov',
  '.avi',
  '.mkv',
  '.webm',
]

export const ALLOWED_DOCUMENT_EXTENSIONS = [
  '.pdf',
  '.doc',
  '.docx',
  '.csv',
  '.xls',
  '.xlsx',
  '.ods',
  '.odt',
  '.txt',
  '.md',
]
